module.exports = __webpack_public_path__ + "img/pin.d838ac80.svg";